var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 115,
    viewBox: "0 0 154 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.f{fill:none;}.a,.b{stroke:#b0bec5;stroke-width:3px;}.a{stroke-linejoin:round;}.c,.d{fill:#b0bec5;}.c{fill-rule:evenodd;}.e{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1013 -320.808)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14350.639,1578.5v55.721",
    transform: "translate(-13264.54 -1229.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14353.361,1578.5v42.573h-19.816",
    transform: "translate(-13276.173 -1229.858)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 11.094,
    transform: "translate(1114.406 415.707)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1071.425 406.934)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M32.1,410.425h32.25a3.645,3.645,0,0,0,3.642-3.645v-.017l.02-10.131a3.662,3.662,0,0,0-3.662-3.662H32.1a3.671,3.671,0,0,0-3.662,3.662v10.131A3.673,3.673,0,0,0,32.1,410.425Zm0-11.964a1.831,1.831,0,0,1,1.831-1.831H62.52a1.831,1.831,0,0,1,1.831,1.831v5.98H32.1Z",
    transform: "translate(-28.438 -392.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.408,
    cy: 1.408,
    r: 1.408,
    transform: "translate(21.098 6.148)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.408,
    cy: 1.408,
    r: 1.408,
    transform: "translate(25.457 6.148)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.408,
    cy: 1.408,
    r: 1.408,
    transform: "translate(29.74 6.148)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1127.425 406.934)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M32.1,410.425h32.25a3.645,3.645,0,0,0,3.642-3.645v-.017l.02-10.131a3.662,3.662,0,0,0-3.662-3.662H32.1a3.671,3.671,0,0,0-3.662,3.662v10.131A3.673,3.673,0,0,0,32.1,410.425Zm0-11.964a1.831,1.831,0,0,1,1.831-1.831H62.52a1.831,1.831,0,0,1,1.831,1.831v5.98H32.1Z",
    transform: "translate(-28.438 -392.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.408,
    cy: 1.408,
    r: 1.408,
    transform: "translate(21.098 6.148)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.408,
    cy: 1.408,
    r: 1.408,
    transform: "translate(25.457 6.148)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.408,
    cy: 1.408,
    r: 1.408,
    transform: "translate(29.74 6.148)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1013.425 384.934)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M32.1,410.425h32.25a3.645,3.645,0,0,0,3.642-3.645v-.017l.02-10.131a3.662,3.662,0,0,0-3.662-3.662H32.1a3.671,3.671,0,0,0-3.662,3.662v10.131A3.673,3.673,0,0,0,32.1,410.425Zm0-11.964a1.831,1.831,0,0,1,1.831-1.831H62.52a1.831,1.831,0,0,1,1.831,1.831v5.98H32.1Z",
    transform: "translate(-28.438 -392.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.408,
    cy: 1.408,
    r: 1.408,
    transform: "translate(21.098 6.148)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.408,
    cy: 1.408,
    r: 1.408,
    transform: "translate(25.457 6.148)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.408,
    cy: 1.408,
    r: 1.408,
    transform: "translate(29.74 6.148)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1062.88 331.269)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(0.12 0.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M8.89,0l8.89,15.859H0Z",
    transform: "translate(28.594 10.875) rotate(90)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 154,
    height: 115,
    transform: "translate(1013 320.808)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStep3);
export default __webpack_public_path__ + "static/media/img_step3.eaa83945730e0b72dd1d78012a3b6ed0.svg";
export { ForwardRef as ReactComponent };